// src/lib/modules.js
export const MODULES = [
  'Punto de Venta',
  'Turnos de Caja (Admin)',
  'Cierre de Turno',
  'Toma de Pedidos',
  'Panel de Despacho',
  'Productos',
  'Inventarios',
  'Entradas',
  'Salidas',
  'Reportes',
  'Gastos',
  'Detalle de Venta',
  'Nómina',
  'Usuarios',
  'Clientes',
  'Auditoría',
  'Panel Financiero',
  'Configuración',
  'Proveedores',
  'Avisos Globales',
];

export const PERMISSION_TYPES = ['Lectura', 'Edición', 'Eliminación'];

const MODULE_ALIASES = {
  Auditoria: 'Auditoría',
  Nomina: 'Nómina',
  Configuracion: 'Configuración',
};

const LEGACY_MODULE_NAMES = Object.fromEntries(
  Object.entries(MODULE_ALIASES).map(([legacyName, canonicalName]) => [canonicalName, legacyName])
);

const PERMISSION_ALIASES = {
  Lectura: ['Lectura'],
  Edición: ['Edición', 'Edicion', 'EdiciÓn'],
  Eliminación: ['Eliminación', 'Eliminacion', 'EliminaciÓn'],
};

const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

export const normalizeModuleName = (moduleName = '') =>
  MODULE_ALIASES[moduleName] || moduleName;

const normalizePermissionType = (type = 'Lectura') => {
  if (type === 'Edicion' || type === 'EdiciÓn') return 'Edición';
  if (type === 'Eliminacion' || type === 'EliminaciÓn') return 'Eliminación';
  return type;
};

export const readPermission = (modulePermissions = {}, type = 'Lectura') => {
  if (!modulePermissions || typeof modulePermissions !== 'object' || Array.isArray(modulePermissions)) {
    return false;
  }

  const canonicalType = normalizePermissionType(type);
  const aliases = PERMISSION_ALIASES[canonicalType];
  if (!aliases) return false;

  for (const key of aliases) {
    if (hasOwn(modulePermissions, key)) return modulePermissions[key] === true;
  }

  return false;
};

const getModulePermissions = (permissions, moduleName) => {
  if (hasOwn(permissions, moduleName)) {
    const canonicalValue = permissions[moduleName];
    return canonicalValue && typeof canonicalValue === 'object' && !Array.isArray(canonicalValue)
      ? canonicalValue
      : null;
  }

  const legacyName = LEGACY_MODULE_NAMES[moduleName];
  const legacyValue = legacyName ? permissions[legacyName] : null;
  return legacyValue && typeof legacyValue === 'object' && !Array.isArray(legacyValue)
    ? legacyValue
    : null;
};

export const normalizePermissionsMatrix = (permissions = {}) => {
  if (!permissions || typeof permissions !== 'object' || Array.isArray(permissions)) return {};

  return MODULES.reduce((normalized, moduleName) => {
    const modulePermissions = getModulePermissions(permissions, moduleName);
    if (!modulePermissions) return normalized;

    normalized[moduleName] = Object.fromEntries(
      PERMISSION_TYPES.map((type) => [type, readPermission(modulePermissions, type)])
    );
    if (moduleName === 'Panel de Despacho') {
      normalized[moduleName]['Cambiar mesa'] = modulePermissions['Cambiar mesa'] === true;
    }
    return normalized;
  }, {});
};

export const makeFullPermissions = () =>
  Object.fromEntries(MODULES.map(m => [m, { Lectura: true, Edición: true, Eliminación: true }]));

export const makeEmptyPermissions = () =>
  Object.fromEntries(MODULES.map(m => [m, { Lectura: false, Edición: false, Eliminación: false }]));

// Mapea cada "view" a un módulo del matrix de permisos
export const VIEW_TO_MODULE = {
  pos: 'Punto de Venta',
  cashDrawers: 'Turnos de Caja (Admin)',
  closeCashRegister: 'Cierre de Turno',
  waiter: 'Toma de Pedidos',
  kitchen: 'Panel de Despacho',
  products: 'Productos',
  inventory: 'Inventarios',
  incoming: 'Entradas',
  outgoing: 'Salidas',
  reports: 'Reportes',
  expenses: 'Gastos',
  salesDetail: 'Detalle de Venta',
  payroll: 'Nómina',
  users: 'Usuarios',
  customers: 'Clientes',
  audit: 'Auditoría',
  financialPanel: 'Panel Financiero',
  settings: 'Configuración',
  suppliers: 'Proveedores',
  globalNotice: 'Avisos Globales',
};

// Devuelve true si el usuario tiene el permiso (Lectura por defecto) para la vista
export const hasAccess = (user, view, type = 'Lectura') => {
  const mod = VIEW_TO_MODULE[view];
  if (!mod) return false;

  const email = (user?.email || '').trim().toLowerCase();
  const username = (user?.username || '').trim().toLowerCase();
  const isProtectedMaster =
    email === 'programacionsebastian94@gmail.com' ||
    username === 'programacionsebastian94@gmail.com';

  if (isProtectedMaster) return true;
  if (mod === 'Avisos Globales') return false;

  const perms = normalizePermissionsMatrix(user?.permissions || {});
  return readPermission(perms[mod], type);
};
